// removed by extract-text-webpack-plugin
module.exports = {"paragraph":"_3IqvM-y2UAPnATpsfpyazp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Paragraph/Paragraph.css
// module id = 178
// module chunks = 0